import {
  EPeriodsChangesActions,
  PeriodsChangesActions,
} from '@myStore/periods-changes/periods-changes.actions';
import {
  initialPeriodsChangesState,
  IPeriodsChangesState,
} from '@myStore/periods-changes/periods-changes.state';

export const periodsChangesReducers = (
  state = initialPeriodsChangesState,
  actions: PeriodsChangesActions
): IPeriodsChangesState => {
  switch (actions.type) {
    case EPeriodsChangesActions.CreatePeriodRequest:
      return {
        ...state,
        isLoading: true,
      };
    case EPeriodsChangesActions.CreatePeriodSuccess:
      return {
        ...state,
        success: true,
        isLoading: false,
      };
    case EPeriodsChangesActions.CreatePeriodFailure:
      return {
        ...state,
        isLoading: false,
        success: false,
        errors: actions.errors,
      };
    case EPeriodsChangesActions.ClearCreatePeriodErrors:
      return {
        ...state,
        success: false,
        errors: null,
      };
    case EPeriodsChangesActions.UpdatePeriodRequest:
      return {
        ...state,
        isLoading: true,
      };
    case EPeriodsChangesActions.UpdatePeriodSuccess:
      return {
        ...state,
        success: true,
        isLoading: false,
      };
    case EPeriodsChangesActions.UpdatePeriodFailure:
      return {
        ...state,
        isLoading: false,
        success: false,
        errors: actions.errors,
      };
    case EPeriodsChangesActions.ClearUpdatePeriodErrors:
      return {
        ...state,
        success: false,
        errors: null,
      };
    case EPeriodsChangesActions.DeletePeriodRequest:
      return {
        ...state,
        isLoading: true,
      };
    case EPeriodsChangesActions.DeletePeriodSuccess:
      return {
        ...state,
        success: true,
        isLoading: false,
      };
    case EPeriodsChangesActions.DeletePeriodFailure:
      return {
        ...state,
        isLoading: false,
        success: false,
        errors: actions.errors,
      };
    case EPeriodsChangesActions.ClearDeletePeriodErrors:
      return {
        ...state,
        success: false,
        errors: null,
      };
    case EPeriodsChangesActions.AddHolidaysToPeriodRequest:
      return {
        ...state,
        isLoading: true,
      };
    case EPeriodsChangesActions.AddHolidaysToPeriodSuccess:
      return {
        ...state,
        success: true,
        isLoading: false,
      };
    case EPeriodsChangesActions.AddHolidaysToPeriodFailure:
      return {
        ...state,
        isLoading: false,
        success: false,
        errors: actions.errors,
      };
    case EPeriodsChangesActions.ClearAddHolidaysToPeriodErrors:
      return {
        ...state,
        success: false,
        errors: null,
      };

    case EPeriodsChangesActions.AddHolidaysToSeveralGroupsRequest:
      return {
        ...state,
        isLoading: true,
      };
    case EPeriodsChangesActions.AddHolidaysToSeveralGroupsSuccess:
      return {
        ...state,
        success: true,
        isLoading: false,
      };
    case EPeriodsChangesActions.AddHolidaysToSeveralGroupsFailure:
      return {
        ...state,
        isLoading: false,
        success: false,
        errors: actions.errors,
      };
    case EPeriodsChangesActions.ClearAddHolidaysToSeveralGroups:
      return {
        ...state,
        success: false,
        errors: null,
      };

    case EPeriodsChangesActions.DeletePeriodHolidaysRequest:
      return {
        ...state,
        isLoading: true,
      };
    case EPeriodsChangesActions.DeletePeriodHolidaysSuccess:
      return {
        ...state,
        success: true,
        isLoading: false,
      };
    case EPeriodsChangesActions.DeletePeriodHolidaysFailure:
      return {
        ...state,
        isLoading: false,
        success: false,
        errors: actions.errors,
      };
    case EPeriodsChangesActions.ClearDeletePeriodHolidaysErrors:
      return {
        ...state,
        success: false,
        errors: null,
      };
    case EPeriodsChangesActions.SetPeriodThemeRequest:
      return { ...state, isLoading: true };
    case EPeriodsChangesActions.SetPeriodThemeSuccess:
      return { ...state, success: true, isLoading: false };
    case EPeriodsChangesActions.SetPeriodThemeFailure:
      return {
        ...state,
        isLoading: false,
        success: false,
        errors: actions.errors,
      };
    case EPeriodsChangesActions.ClearSetPeriodTheme:
      return { ...state, success: false, errors: null };

    default:
      return state;
  }
};
